export default __webpack_public_path__ + "static/media/job_offer5_m.3b9e236e.jpg";